import request from "@/api/request";
import { BlogPostResponse } from "@/interfaces/Blog/BlogPostResponse";
import { BlogListResponse } from "@/interfaces/Blog/BlogListResponse";
import { BlogPostCategory } from "@/interfaces/Blog/BlogPostCategory";

class BlogService {
  static async getPost(lang: string, alias: string): Promise<BlogPostResponse> {
    return await request.get(`/blog/${lang}/post/${alias}`);
  }

  static async getList(lang: string, page: number, title: string, category: string | null): Promise<BlogListResponse> {
    return await request.get(`/blog/${lang}`, { page, title, category });
  }

  static async getCategories(lang: string): Promise<BlogPostCategory[]> {
    return await request.get(`/blog/${lang}/categories`);
  }
}

export default BlogService;
